import {Injectable} from "@angular/core";
import {Apollo, gql} from "apollo-angular";
import {from, Observable} from "rxjs";
import {first, map} from "rxjs/operators";
import {
  AlternativeSearchInput,
  AlternativeSearchResult,
  NeighbourMailInput,
  NeighbourMailResult, ValuationMailInput, ValuationMailResult
} from "./assistants.model";
import {AgentProfile} from "@common/models/agent-profile";
import {AgentCompany} from "@common/models/agent-company";

@Injectable({providedIn: 'root'})
export class AssistantsApiFacade {
  constructor(private readonly apollo: Apollo) { }

  createNeighbourMail$(input: NeighbourMailInput, agentProfile: AgentProfile, agentCompany: AgentCompany): Observable<NeighbourMailResult> {
    console.log('createNeighbourMail$ api facade', input);
    return this.apollo
      .mutate({
        mutation: gql`
          mutation CreateNeighbourMail($input: NeighbourMailInput!, $agentProfile: AgentProfile! $agentCompany: AgentCompany!) {
            neighbourMail(input: $input, agentProfile: $agentProfile, agentCompany: $agentCompany) {
              result
            }
          }
        `,
        variables: {
          input: input,
          agentProfile: agentProfile,
          agentCompany: agentCompany,
        },
      })
      .pipe(
        first(),
        map((res: any) => {
          return res.data.neighbourMail;
        })
      )
  }

  createAlternativeSearch$(input: AlternativeSearchInput, agentProfile: AgentProfile, agentCompany: AgentCompany): Observable<AlternativeSearchResult> {
    console.log('createAlternativeSearch$ api facade', input);
    return this.apollo
    .mutate({
      mutation: gql`
        mutation CreateAlternativeSearch($input: AlternativeSearchInput!, $agentProfile: AgentProfile! $agentCompany: AgentCompany!) {
          alternativeSearch(input: $input, agentProfile: $agentProfile, agentCompany: $agentCompany) {
            result
          }
        }
      `,
      variables: {
        input: input,
        agentProfile: agentProfile,
        agentCompany: agentCompany,
      },
    })
    .pipe(
      first(),
      map((res: any) => {
        return res.data.alternativeSearch;
      })
    )
  }

  createValuationMail$(input: ValuationMailInput, agentProfile: AgentProfile, agentCompany: AgentCompany): Observable<ValuationMailResult> {
    console.log('createValuationMail$ api facade', input);
    return this.apollo
    .mutate({
      mutation: gql`
        mutation CreateValuationMail($input: ValuationMailInput!, $agentProfile: AgentProfile! $agentCompany: AgentCompany!) {
          valuationMail(input: $input, agentProfile: $agentProfile, agentCompany: $agentCompany) {
            result
          }
        }
      `,
      variables: {
        input: input,
        agentProfile: agentProfile,
        agentCompany: agentCompany,
      },
    })
    .pipe(
      first(),
      map((res: any) => {
        return res.data.valuationMail;
      })
    )
  }

}
